import Instrument from "shared/games/instruments/Instrument";
import { Musician } from "./Musician";

export const loopAudioFiles = [
  "default",
  "comp_opto1",
  "comp_opto2",
  "comp_opto4",
  "comp_opto7",
  "comp_opto10",
] as const;

export const audioFileGainReductionLookup: {
  [file in typeof loopAudioFiles[number]]: number;
} = {
  default: 0,
  comp_opto1: 1,
  comp_opto2: 2,
  comp_opto4: 4,
  comp_opto7: 7,
  comp_opto10: 10,
};

export type LooopAudioFiles = {
  [file in typeof loopAudioFiles[number]]: string;
};

export interface LooopInstrument {
  instrument: Instrument;
  audio_files: LooopAudioFiles;
}

export interface Looop {
  id: number;
  slug: string;
  title: string;
  description?: string;
  bpm: number;
  measures: number;
  base_audio_url: string;
  instruments: {
    [instrumentId: string]: LooopInstrument;
  };
  musician: Musician;
}
